import {
  FETCH_SUBCOLLECTIONS_REQUEST,
  FETCH_SUBCOLLECTIONS_SUCCESS,
  FETCH_SUBCOLLECTIONS_FAILURE,
  ADD_SUBCOLLECTION_REQUEST,
  ADD_SUBCOLLECTION_SUCCESS,
  ADD_SUBCOLLECTION_FAILURE,
  UPDATE_SUBCOLLECTION_REQUEST,
  UPDATE_SUBCOLLECTION_SUCCESS,
  UPDATE_SUBCOLLECTION_FAILURE,
  DELETE_SUBCOLLECTION_REQUEST,
  DELETE_SUBCOLLECTION_SUCCESS,
  DELETE_SUBCOLLECTION_FAILURE,
  SET_SUBCOLLECTION_EDIT,
  CLEAR_SUBCOLLECTION_EDIT,
} from '../../../../types/masters/styles/subCollection/subCollectionTypes';

const initialState = {
  list: [],
  loading: false,
  error: null,
  editingSubCollection: null,
};

const subCollectionReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_SUBCOLLECTIONS_REQUEST:
    case ADD_SUBCOLLECTION_REQUEST:
    case UPDATE_SUBCOLLECTION_REQUEST:
    case DELETE_SUBCOLLECTION_REQUEST:
      return { ...state, loading: true, error: null };
    case FETCH_SUBCOLLECTIONS_SUCCESS:
      return { ...state, loading: false, list: action.payload, error: null };
    case ADD_SUBCOLLECTION_SUCCESS:
    case UPDATE_SUBCOLLECTION_SUCCESS:
    case DELETE_SUBCOLLECTION_SUCCESS:
      return { ...state, loading: false, error: null };
    case FETCH_SUBCOLLECTIONS_FAILURE:
    case ADD_SUBCOLLECTION_FAILURE:
    case UPDATE_SUBCOLLECTION_FAILURE:
    case DELETE_SUBCOLLECTION_FAILURE:
      return { ...state, loading: false, error: action.payload };
    case SET_SUBCOLLECTION_EDIT:
      return { ...state, editingSubCollection: action.payload };
    case CLEAR_SUBCOLLECTION_EDIT:
      return { ...state, editingSubCollection: null };
    default:
      return state;
  }
};

export default subCollectionReducer; 